import { eventService } from '@/shared/services/EventService';
import { urlService } from '@/shared/services/UrlService';
import { default as axios, AxiosResponse } from 'axios';
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { IRootHypermediaRepresentation } from '../shared/contracts/RootContract';
import {
    IUserAllocationHypermediaRepresentation,
    IUserHypermediaRepresentation
} from '../shared/contracts/UserContract';
import { IRootState, IUserState } from './contract';

const exportState: IUserState = {
    user: undefined,
    activeAllocations: undefined
};

const mutations: MutationTree<IUserState> = {
    userLoaded(state, payload: IUserHypermediaRepresentation) {
        state.user = payload;
        eventService.setUserType(payload);
    },
    activeAllocationsLoaded(state, payload: IUserAllocationHypermediaRepresentation[]) {
        state.activeAllocations = payload;
    }
};

const actions: ActionTree<IUserState, IRootState> = {
    async fetchUser({ commit, state, rootState }): Promise<void> {
        if (!state.user) {
            const response: AxiosResponse<IUserHypermediaRepresentation> = await axios.get(
                (rootState.root as IRootHypermediaRepresentation)._links.user.href
            );
            await commit('userLoaded', response && response.data);
        }
    },

    async fetchActiveAllocationsForUser({ commit, state, rootState }): Promise<void> {
        if (!state.activeAllocations) {
            const url = urlService.replaceURIPlaceholders(
                (rootState.root as IRootHypermediaRepresentation)._links.user_allocations.href,
                {
                    userId: state.user.id.toString()
                }
            );
            const userAllocations = await axios.get(url);
            await commit('activeAllocationsLoaded', userAllocations.data);
        }
    }
};

const getters: GetterTree<IUserState, IRootState> = {};
const namespaced: boolean = true;

export const user: Module<IUserState, IRootState> = {
    namespaced,
    state: exportState,
    getters,
    actions,
    mutations
};
